import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ETemplateCategory } from '@sharedInterfaces/IEmployeeTalkTemplate';
import type EmployeeTalk from '@src/Objects/EmployeeTalk';

export enum EEmployeeTalkAction {
    SET_EMPLOYEE_TALKS = 'SET_EMPLOYEE_TALKS',
    ADD_EMPLOYEE_TALK = 'ADD_EMPLOYEE_TALK',
    UPDATE_EMPLOYEE_TALK = 'UPDATE_EMPLOYEE_TALK',
    DELETE_EMPLOYEE_TALK = 'DELETE_EMPLOYEE_TALK',
}

const initialState: EmployeeTalk[] = [];

const employeeTalksSlice = createSlice({
    name: 'employeeTalks',
    initialState,
    reducers: {
        setEmployeeTalks: (state, action: PayloadAction<EmployeeTalk[]>) => {
            return action.payload;
        },
        addEmployeeTalk: (state, action: PayloadAction<EmployeeTalk>) => {
            state.push(action.payload);
        },
        updateEmployeeTalk: (state, action: PayloadAction<EmployeeTalk>) => {
            const index = state.findIndex((talk) => talk.id === action.payload.id);
            if (index !== -1) {
                state[index] = action.payload;
            } else {
                state.push(action.payload);
            }
        },
        deleteEmployeeTalk: (state, action: PayloadAction<number>) => {
            return state.filter((talk) => talk.id !== action.payload);
        },
    },
});

// Selectors
export const selectCurrentUserOnboardingTalk = (state: {
    employeeTalks: EmployeeTalk[];
    employee: { id?: number };
}) => {
    if (!state.employee?.id) return null;

    return (
        state.employeeTalks.find(
            (talk) =>
                talk.employeeId === state.employee.id &&
                (talk.templateData?.templateCategory === ETemplateCategory.ONBOARDING ||
                    talk.title?.toLowerCase().includes('onboarding') ||
                    talk.templateData?.title?.toLowerCase().includes('onboarding')),
        ) || null
    );
};

export const { setEmployeeTalks, addEmployeeTalk, updateEmployeeTalk, deleteEmployeeTalk } = employeeTalksSlice.actions;
export default employeeTalksSlice.reducer;
